/** pobieranie listy studentów do wyszukiwarki */
export const GET_STUDENT_LIST = 'STUDENT_FINDER/GET_STUDENT_LIST';
export const GET_STUDENT_LIST_SUCCESS = 'STUDENT_FINDER/GET_STUDENT_LIST_SUCCESS';
export const GET_STUDENT_LIST_FAIL = 'STUDENT_FINDER/GET_STUDENT_LIST_FAIL';
export const GET_STUDENT_LIST_CANCEL = 'STUDENT_FINDER/GET_STUDENT_LIST_CANCEL';

/** wybranie studenta z listy */
export const CHOOSE_SINGLE_STUDENT = 'STUDENT_FINDER/CHOOSE_SINGLE_STUDENT';

/** pobranie listy przedmiotów dla danego studenta */
export const GET_SUBJECT_FOR_STUDENT_LIST = 'STUDENT_FINDER/GET_SUBJECT_FOR_STUDENT_LIST';
export const GET_SUBJECT_FOR_STUDENT_LIST_SUCCESS = 'STUDENT_FINDER/GET_SUBJECT_FOR_STUDENT_LIST_SUCCESS';
export const GET_SUBJECT_FOR_STUDENT_LIST_FAIL = 'STUDENT_FINDER/GET_SUBJECT_FOR_STUDENT_LIST_FAIL';

/** resetowanie reducera do init state */
export const RESET_REDUCER = 'STUDENT_FINDER/RESET_REDUCER';

/** otwieranie i zamykanie selecta */
export const CHANGE_SELECT_OPEN = 'STUDENT_FINDER/CHANGE_SELECT_OPEN';